module.exports = __webpack_public_path__ + "static/media/28092018.983ce4c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/28092018.png
// module id = 246
// module chunks = 0